import { type WorkflowConfigurationFactory } from './workflowConfigs'

/* eslint-disable @typescript-eslint/naming-convention */
export const workflowPrioritizedColumns = {
  input_data: 1,
  upc_code: 2,
  image: 3,
  name: 4,
  brand: 5,
}

export const ignoreColumnNames = ['product_id', 'locale_id', 'classified_type']

export const generalWorkflowConfigFactory: WorkflowConfigurationFactory = {
  regex: '*',
  priority: 0,
  build: () => ({
    name: 'general_workflow',
    showCombineButton: false,
    showClassifiedType: false,
    showDueDate: true,
    showLocaleId: false,
    sizeFlagChangeCombined: false,
    getColumnConfiguration: (componentType, componentName) => {
      if (ignoreColumnNames.includes(componentName))
        return {
          isVisible: false,
        }
      return {
        componentTypeLayers: [],
        showComponentTypeLabels: false,
        isFlaggable: true,
        isSuggestible: false,
        isVisible: true,
        isFreezable: false,
        ordering: workflowPrioritizedColumns[componentName] ?? 9999,
      }
    },
  }),
}
